import React, { useState, useEffect } from "react";
import LogoSection from "../basic/LogoSection";
import HeaderSection from "../basic/HeaderSection";
import PlanSection from "./PlanSection";
import StateContainer from "./StateContainer";
import StateProducts from "./StateProducts";
import PoliciesSection from "./PoliciesSection";
import NeedInsurance from "./NeedInsurance";
import ArticleSection from "./ArticleSection";
import FooterSection from "../basic/FooterSection";
import DrivingOptions from "./DrivingOptions";
import FindingPolicies from "./FindingPolicies";
import DiscountsSectionCity from "./DisountSectionCity";
import LocationSection from "./LocationSection";
import AboutUs from "./AboutUs";
import SEO from "../seo";
import Loader from "../basic/loader";
const storyblokAPI = process.env.GATSBY_APP_STORYBLOK_TOKEN;
const storyblokVersion = process.env.GATSBY_APP_STORYBLOK_VERSION;

export default function Index(props) {
  const [storyLists, setStories] = useState([]);
  const [aboutUs, setAboutUS] = useState([]);
  const [bannnerData, setBannerData] = useState([]);
  const [isPageloaded, setisPageloaded] = useState(true);
  const url = props.url;
  const state = props.state;
  const city = props.city;
  const allowedUrls = [
    "auto-insurance-aurora-il",
    "auto-insurance-chicago-il",
    "auto-insurance-evanston-il",
    "auto-insurance-naperville-il",
  ];

  const locationSectionShowUrl = [
    "auto-insurance-blue-island-il"
  ]

  let dynamic_state = ''
  switch(state) {
    case 'IN':
      dynamic_state = 'indiana'
      break;
    case 'IL':
      dynamic_state = 'illinois'
      break;
    case 'MO':
      dynamic_state = 'missouri'
      break;
    case 'IA':
      dynamic_state = 'iowa'
      break;
    case 'KS':
      dynamic_state = 'kansas'
      break;
    case 'AR':
      dynamic_state = 'arkansas'
      break;
    case 'TX':
      dynamic_state = 'texas'
  }

  useEffect(() => {
    const api =
      "https://api.storyblok.com/v2/cdn/stories?starts_with=insureonline/city-pages/states/" +
      dynamic_state +
      "/" +
      url +
      "&token=" +
      storyblokAPI +
      "&version=" +
      storyblokVersion;
    fetch(api)
      .then((response) => response.json())
      .then((json) => {
        setStories(json.stories);
        setisPageloaded(false);
      })
      .catch((error) => {
        console.log(error, "error");
      });
  }, []);

  const api =
    "https://api.storyblok.com/v2/cdn/stories?starts_with=insureonline/city-pages/common/about-us&token=" +
    storyblokAPI +
    "&version=" +
    storyblokVersion;
  useEffect(() => {
    fetch(api)
      .then((response) => response.json())
      .then((json) => {
        setAboutUS(json.stories);
        // setisPageloaded(false);
      })
      .catch((error) => {
        console.log(error, "error");
      });
  }, []);

  const banner =
    "https://api.storyblok.com/v2/cdn/stories?starts_with=insureonline/city-pages/common/get-quick-link-on-banner&token=" +
    storyblokAPI +
    "&version=" +
    storyblokVersion;
  useEffect(() => {
    fetch(banner)
      .then((response) => response.json())
      .then((json) => {
        setBannerData(json.stories);
        // setisPageloaded(false);
      })
      .catch((error) => {
        console.log(error, "error");
      });
  }, []);

  const [planSectoinData, setplanSectoinData] = useState([]);
  const [legalReqData, setLegalReq] = useState([]);
  const [insFactor, setInsuranceFactor] = useState([]);
  const [drivingOptipons, setdrivingOptipons] = useState([]);
  const [needLeftInsurance, setLeftInsurance] = useState([]);
  const [needRightInsurance, setRightInsurance] = useState([]);
  const [article, setArticle] = useState([]);
  const [metaData, setMetaData] = useState([]);
  const [policyForDrivers, setPolicyForDrivers] = useState([]);
  const [policySection, setpolicySection] = useState([]);
  const [heroSection, setHeroSection] = useState([]);
  const [locationSectionData, setLocationSectionData] = useState([]);
  const [discount, setDiscount] = useState([]);

  useEffect(() => {
    let planSectionD = storyLists.filter(palnFindbySlug);
    function palnFindbySlug(arg) {
      if (
        arg.full_slug ===
        "insureonline/city-pages/states/" +
          dynamic_state +
          "/" +
          url +
          "/help-with-auto-insurance"
      ) {
        return arg;
      }
    }
    setplanSectoinData(planSectionD[0]);

    let stateContaineData = storyLists.filter(stateFindbySlug);
    function stateFindbySlug(arg) {
      if (
        arg.full_slug ===
        "insureonline/city-pages/states/" +
          dynamic_state +
          "/" +
          url +
          "/what-are-the-legal-requirements"
      ) {
        return arg;
      }
    }
    setLegalReq(stateContaineData[0]);

    let discount = storyLists.filter(discountFindbySlug);
    function discountFindbySlug(arg) {
      if (
        arg.full_slug ===
        "insureonline/city-pages/states/" +
          dynamic_state +
          "/" +
          url +
          "/available-car-discounts"
      ) {
        return arg;
      }
    }
    setDiscount(discount[0]);

    let findPolicesData = storyLists.filter(PoliciesFindbySlug);
    function PoliciesFindbySlug(arg) {
      if (
        arg.full_slug ===
        "insureonline/city-pages/states/" +
          dynamic_state +
          "/" +
          url +
          "/policy-for-different-drivers"
      ) {
        return arg;
      }
    }
    setPolicyForDrivers(findPolicesData[0]);

    let factor = storyLists.filter(factorDFindbySlug);
    function factorDFindbySlug(arg) {
      if (
        arg.full_slug ===
        "insureonline/city-pages/states/" +
          dynamic_state +
          "/" +
          url +
          "/auto-insurance-factor"
      ) {
        return arg;
      }
    }
    setInsuranceFactor(factor[0]);

    let optionsD = storyLists?.filter(optionsFindbySlug);
    function optionsFindbySlug(arg) {
      if (
        arg?.full_slug ===
        "insureonline/city-pages/states/" +
          dynamic_state +
          "/" +
          url +
          "/driving-options"
      ) {
        return arg;
      }
    }
    setdrivingOptipons(optionsD[0]);

    let needLeftInsurance = storyLists?.filter(needFindbySlug);
    function needFindbySlug(arg) {
      if (
        arg?.full_slug ===
        "insureonline/city-pages/states/" +
          dynamic_state +
          "/" +
          url +
          "/need-auto-insurance-set-1"
      ) {
        return arg;
      }
    }
    setLeftInsurance(needLeftInsurance[0]);

    let needRightInsurance = storyLists?.filter(rightFindbySlug);
    function rightFindbySlug(arg) {
      if (
        arg?.full_slug ===
        "insureonline/city-pages/states/" +
          dynamic_state +
          "/" +
          url +
          "/need-auto-insurance-set-2"
      ) {
        return arg;
      }
    }
    setRightInsurance(needRightInsurance[0]);

    let article = storyLists.filter(auroaFindbyAt);
    function auroaFindbyAt(arg) {
      if (
        arg.full_slug ===
        "insureonline/city-pages/states/" +
          dynamic_state +
          "/" +
          url +
          "/article-section"
      ) {
        return arg;
      }
    }
    setArticle(article[0]);

    let metaData = storyLists?.filter(metaDataFindbySlug);
    function metaDataFindbySlug(arg) {
      console.log(arg, "*******119");
      if (
        arg?.full_slug ===
        "insureonline/city-pages/states/" +
          dynamic_state +
          "/" +
          url +
          "/meta-data"
      ) {
        return arg;
      }
    }
    setMetaData(metaData[0]);

    let sectionD = storyLists?.filter(findSectionData);
    function findSectionData(arg) {
      if (
        arg?.full_slug ===
        "insureonline/city-pages/states/" +
          dynamic_state +
          "/" +
          url +
          "/what-to-see"
      ) {
        return arg;
      }
    }
    setpolicySection(sectionD[0]);

    let heroSection = storyLists?.filter(findHero);
    function findHero(arg) {
      if (
        arg?.full_slug ===
        "insureonline/city-pages/states/" +
          dynamic_state +
          "/" +
          url +
          "/hero-section"
      ) {
        return arg;
      }
    }
    setHeroSection(heroSection[0]);

    let locationSectionData = storyLists?.filter(locationSectionBySlug);
    function locationSectionBySlug(arg) {
      if (
        arg?.full_slug ===
        "insureonline/city-pages/states/" +
          dynamic_state +
          "/" +
          url +
          "/location-section"
      ) {
        return arg;
      }
    }
    console.log("locationData",locationSectionData);
    setLocationSectionData(locationSectionData[0]);
  }, [storyLists]);

  function withLoader() {
    return (
      <div className="main-wrapper">
        <Loader />
      </div>
    );
  }

  function withOutLoader() {
    return (
      <div className="main-wrapper">
        {metaData && (
          <SEO
            data={metaData}
            title={metaData?.content?.Meta?.title}
            description={metaData?.content?.Meta?.description}
            keyword={metaData?.content?.keywords}
          />
        )}
        <LogoSection bannnerData={bannnerData} />
        <HeaderSection
          heroSection={heroSection}
          bannerData={bannnerData}
          RightImage={needRightInsurance}
          city={city}
          state={state}
        />
        {locationSectionShowUrl.includes(url) && (
          <LocationSection LocationSection={locationSectionData} />
        )}
        <PlanSection planSection={planSectoinData} />{" "}
        {/*Get car insurance in Chicago, Illinois with InsureOnline.com. Here, you can:*/}
        <StateContainer StateContainer={legalReqData} />{" "}
        {/* What Are the Legal Requirements for Car Insurance in Illinois? */}
        <StateProducts StateProducts={insFactor} />
        <DiscountsSectionCity DiscountsSectionCity={discount} />
        <DrivingOptions DrivingOptions={drivingOptipons} />
        <PoliciesSection PoliciesSection={policySection} />
        <FindingPolicies LeftImage={policyForDrivers} />
        <AboutUs data={aboutUs[0]} />
        <NeedInsurance
          LeftImage={needLeftInsurance}
          RightImage={needRightInsurance}
        />
        {allowedUrls.includes(url) && (
          <ArticleSection ArticleSection={article} />
        )}
        <FooterSection />
      </div>
    );
  }

  function MainContent() {
    if (isPageloaded) {
      return withLoader();
    }
    return withOutLoader();
  }

  return <MainContent />;
}
